import { render, staticRenderFns } from "./approval_list.vue?vue&type=template&id=e847e66e&scoped=true"
import script from "./approval_list.vue?vue&type=script&lang=js"
export * from "./approval_list.vue?vue&type=script&lang=js"
import style0 from "./approval_list.vue?vue&type=style&index=0&id=e847e66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e847e66e",
  null
  
)

export default component.exports